// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6fbc2e3c] .modal-body{position:relative;flex:1 1 auto;padding:2rem}", ""]);
// Exports
module.exports = exports;
